'use strict';
const LIST_PREFERENCE_KEY = 'gold-file-list-preferences',
	OLD_STORED_LIST_PREFERENCE_KEY = 'gold-file-list-type',
	DEFAULT_FILTER_NO_STORAGE = 'allMaps',
	LIST_PREFERENCE_DEFAULTS = {
		listType: 'icons',
		sortType: 'descriptionAscending',
		filterType: 'default',
		openType: 'inplace',
		listFilterInvert: false
	},
	GoldFileListPreferences = function GoldFileListPreferences(storage) {
		const self = this,
			preferenceDefaults = storage ? LIST_PREFERENCE_DEFAULTS : Object.assign({}, LIST_PREFERENCE_DEFAULTS, {filterType: DEFAULT_FILTER_NO_STORAGE}),
			loadPreferences = () => {
				const oldStoredListType = storage && storage.getItem(OLD_STORED_LIST_PREFERENCE_KEY),
					storedPreferences = storage && storage.getItem(LIST_PREFERENCE_KEY),
					prefs = (storedPreferences && Object.assign({}, preferenceDefaults, storedPreferences)) || Object.assign({}, preferenceDefaults);
				if (oldStoredListType) {
					storage.removeItem(OLD_STORED_LIST_PREFERENCE_KEY);
					if (!storedPreferences) {
						prefs.listType = oldStoredListType;
						storage.setItem(LIST_PREFERENCE_KEY, prefs);
					}
				}
				return prefs;
			},
			preferences = loadPreferences(),
			storablePreferences = () => {
				const preferenceKeys = Object.keys(preferenceDefaults),
					cleaned = Object.assign({}, preferences);
				Object.keys(preferences).forEach((key) => {
					if (!preferenceKeys.includes(key)) {
						delete cleaned[key];
					}
				});
				return cleaned;
			},
			storePreferences = () => {
				if (!storage) {
					throw new Error('no-storage');
				}
				storage.setItem(LIST_PREFERENCE_KEY, storablePreferences());
			};


		self.setListFilterInvert = doInvert => {
			preferences.listFilterInvert = !!doInvert;
			storePreferences();
		};
		self.getListFilterInvert = () => {
			return !!(preferences.listFilterInvert);
		};
		self.getFilterType = () => {
			return preferences.filterType;
		};
		self.setFilterType = (filterType)  => {
			preferences.filterType = filterType;
			storePreferences();
		};
		self.getOpenType = () => {
			return preferences.openType;
		};

		self.setOpenType = (openType)  => {
			preferences.openType = openType;
			storePreferences();
		};

		self.getListType = () => {
			return preferences.listType;
		};
		self.setListType = (listType)  => {
			preferences.listType = listType;
			storePreferences();
		};

		self.getSortType = () => {
			return preferences.sortType;
		};
		self.setSortType = (sortType) => {
			preferences.sortType = sortType;
			storePreferences();
		};
		self.getPreferences = () => Object.assign({}, preferences);
	};
GoldFileListPreferences.LIST_PREFERENCE_DEFAULTS = LIST_PREFERENCE_DEFAULTS;
module.exports = GoldFileListPreferences;
